import { gettext } from '@core/lib/utils/localization';

export enum LANGUAGE_CODE {
  ENGLISH = 'en',
  SPANISH = 'es',
  PORTUGUESE = 'pt',
  CHINESE = 'zh',
  JAPANESE = 'ja',
  KOREAN = 'ko',
  VIETNAMESE = 'vi',
  RUSSIAN = 'ru',
  TURKISH = 'tr',
  FRENCH = 'fr',
}

export const languages = [
  {
    id: LANGUAGE_CODE.ENGLISH,
    title: gettext('language.english'),
  },
  {
    id: LANGUAGE_CODE.JAPANESE,
    title: gettext('language.japanese'),
  },
  {
    id: LANGUAGE_CODE.CHINESE,
    title: gettext('language.chinese-simplified'),
  },
  {
    id: LANGUAGE_CODE.KOREAN,
    title: gettext('language.korean'),
  },
  {
    id: LANGUAGE_CODE.VIETNAMESE,
    title: gettext('language.vietnamese'),
  },
  {
    id: LANGUAGE_CODE.RUSSIAN,
    title: gettext('language.russian'),
  },
  {
    id: LANGUAGE_CODE.PORTUGUESE,
    title: gettext('language.portuguese.brazil'),
  },
  {
    id: LANGUAGE_CODE.SPANISH,
    title: gettext('language.spanish'),
  },
  {
    id: LANGUAGE_CODE.TURKISH,
    title: gettext('language.turkish'),
  },
  {
    id: LANGUAGE_CODE.FRENCH,
    title: gettext('language.french'),
  },
];
